/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
export type ItemSelect_ItemFragment = { __typename: 'Item', id: string, originVersionNumber?: number | null, pathForPdf: string, pathSortable: string, title: string };

export const ItemSelect_ItemFragmentDoc = gql`
    fragment ItemSelect_Item on Item {
  id
  originVersionNumber
  pathForPdf
  pathSortable
  title
}
    `;